import * as Fmt from "../../format";
import { KV } from "../../components";
import { AVG_EBITDA_LABEL } from "../../presentation/return-labels";

export const KPI_OPTIONS = [
  {
    key: "developerUngearedEarlyExitIrr",
    label: "Ungeared IRR (selected hold-and-sell)",
    fmt: (v: number) => Fmt.pct(v, 1),
  },
  {
    key: "developerIrr",
    label: "Developer IRR (ungeared, sale at completion)",
    fmt: (v: number) => Fmt.pct(v, 1),
  },
  {
    key: "developerMarginOnCost",
    label: "Developer margin / cost",
    fmt: (v: number) => Fmt.pct(v, 1),
  },
  {
    key: "developerYieldOnCost",
    label: "Developer yield on cost",
    fmt: (v: number) => Fmt.pct(v, 2),
  },
  {
    key: "developerGearedIrr",
    label: "Geared IRR (sale at completion)",
    fmt: (v: number) => Fmt.pct(v, 1),
  },
  {
    key: "developerGearedEarlyExitIrr",
    label: "Geared IRR (selected early exit)",
    fmt: (v: number) => Fmt.pct(v, 1),
  },
  {
    key: "developerGearedWholeOfLifeIrr",
    label: "Geared IRR (refinance / hold / exit)",
    fmt: (v: number) => Fmt.pct(v, 1),
  },
  {
    key: "developerYieldOnCash",
    label: "Yield on cash (geared)",
    fmt: (v: number) => Fmt.pct(v, 2),
  },
  {
    key: "reddamNpv",
    label: "Operator NPV",
    fmt: (v: number) => Fmt.compactCurrency(v),
  },
  {
    key: "avgEbitda",
    label: AVG_EBITDA_LABEL,
    fmt: (v: number) => Fmt.compactCurrency(v),
  },
];

export function KVCard({
  title,
  rows,
}: {
  title: string;
  rows: [string, string][];
}) {
  return (
    <div className="card elevated card-pad-lg">
      <div className="eyebrow" style={{ marginBottom: 10 }}>
        {title}
      </div>
      <div>
        {rows.map(([k, v]) => (
          <KV key={k} k={k} v={v} />
        ))}
      </div>
    </div>
  );
}

export { DEFAULT_MC_VARIABLES } from "../../solvers/monte-carlo-variables";

export function Histogram({
  counts,
  width = 360,
  height = 140,
  color = "hsl(210 60% 55%)",
}: {
  counts: number[];
  width?: number;
  height?: number;
  color?: string;
}) {
  const maxCount = Math.max(1, ...counts);
  const barWidth = width / counts.length;
  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      style={{
        display: "block",
        width: "100%",
        height: "auto",
        maxWidth: width,
      }}
    >
      {counts.map((c, i) => (
        <rect
          key={i}
          x={i * barWidth + 1}
          y={height - (c / maxCount) * (height - 20)}
          width={barWidth - 2}
          height={(c / maxCount) * (height - 20)}
          fill={color}
          opacity={0.8}
          rx={2}
        />
      ))}
    </svg>
  );
}
